<template>
  <div class="input-switch" v-on:click.prevent="click">
    <input type="checkbox" :id="_uid" v-model="checked"/><label :for="_uid">Toggle</label>
    <span class="no">Ne</span>
    <span class="yes">Da</span>
  </div>
</template>

<script>

export default {
  name: 'Switch',
  props: ['checked', 'id'],
  methods:
  {
    click: function()
    {
      var me = this;
      me.$emit('change', !me.checked, me.id);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lib/Switch.vue